export default function typeFilter() {
    const type = window.location.pathname;
    switch (type) {
        case '/resources': return '';
        case '/blogs': return 'blog';
        case '/guides': return 'guide';
        case '/research': return 'research';
        case '/client-story': return 'client_story';
        case '/podcasts': return 'podcast';
        case '/webinars': return 'webinar';
        case '/workshops': return 'workshop';
        case '/events': return 'event';
        default: return '';
    }
}
